(()=>{
  const __shopifySectionId=document.currentScript?.dataset.sectionId||'';
  const root=document.getElementById(("YurchakCartRecommendations-" + __shopifySectionId + ""));
  if(!root||root.dataset.ycrReady==='true')return;
  root.dataset.ycrReady='true';
  const core=window.YurchakCartCore;
  const routeRoot=()=>window.Shopify?.routes?.root||'/';

  const fetchCart=()=>core?.fetchCart
    ? core.fetchCart()
    : fetch(routeRoot()+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}}).then(async response=>{
        const data=await response.json();
        if(!response.ok||data?.status)throw new Error(data?.description||data?.message||'Could not refresh cart.');
        return data;
      });

  const addItem=id=>core?.addItems
    ? core.addItems([{id:Number(id),quantity:1}])
    : fetch(window.routes?.cart_add_url||((window.Shopify?.routes?.root || '/') + 'cart/add.js'),{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json',Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({items:[{id:Number(id),quantity:1}]})
      }).then(async response=>{
        const data=await response.json();
        if(!response.ok||data?.status)throw new Error(data?.description||data?.message||'Could not add product.');
        return data;
      });

  const refreshCartSection=async()=>{
    const current=document.querySelector('[data-ycart-root]');
    const sectionId=current?.dataset?.sectionId;
    if(!current||!sectionId)return false;

    const url=new URL(window.location.href);
    url.searchParams.set('section_id',sectionId);
    url.hash='';

    const response=await fetch(url.toString(),{
      credentials:'same-origin',
      cache:'no-store',
      headers:{'X-Requested-With':'XMLHttpRequest'}
    });
    if(!response.ok)return false;

    const html=await response.text();
    const doc=new DOMParser().parseFromString(html,'text/html');
    const fresh=doc.getElementById('YurchakCart-'+sectionId);
    if(!fresh)return false;

    current.replaceWith(fresh);
    window.YurchakCartSectionInit?.();
    return true;
  };

  root.addEventListener('click',async event=>{
    const btn=event.target.closest('[data-ycr-add]');
    if(!btn||!root.contains(btn)||btn.dataset.busy==='1')return;

    const card=btn.closest('[data-ycr-card]');
    const id=Number(card?.dataset.variantId||0);
    if(!id)return;

    event.preventDefault();
    btn.dataset.busy='1';
    btn.classList.add('is-loading');
    btn.disabled=true;

    try{
      await addItem(id);
      const cart=await fetchCart();
      await refreshCartSection();

      core?.emitItemAdded?.(cart,'yurchak-cart-recommendations',{productVariantId:id});

      card?.remove();
      if(!root.querySelector('[data-ycr-card]'))root.remove();
    }catch(error){
      console.error(error);
      btn.dataset.busy='0';
      btn.disabled=false;
      btn.classList.remove('is-loading');
      btn.setAttribute('title',error?.message||'Could not add product.');
    }
  });
})();
